export const GENDER = {
  MALE: 1,
  FEMALE: 2,
  OTHER: 3,
  ALL: 4,
};

export const WORK = {
  NOT_REQUIREMENT: 1,
  ONETOTHREE: 2,
  THREETOFIVE: 3,
  FIVETOTEN: 4,
  AFTERTEN: 5,
};

export const EDUCATION = {
  HIGHT_SCHOOL: 1,
  INTERMEDIATE: 2,
  COLLEGES: 3,
  UNIVERSITY: 4,
  AFTER_UNIVERSITY: 5,
};
